import { useCurrentUser } from './useCurrentUser';
import { GET_TOOL_PREFERENCES } from 'modules/Apollo/queries';
import { useLazyQuery } from '@apollo/client';
import { useCrossTabEventsListener } from '@sironamedical/common/hooks/useCrossTabEventsListener';
import { NameSpaces, CrossWindowDataRefetchType } from 'modules/EventsManager';
import { WithApolloContext } from 'modules/Apollo/types';

/**
 * Enables cross-window synchronization of Viewer settings changes. Mounting this hook will
 * subscribe the window to inbound requests data refetch events.
 */
export const useViewerSettingsSync = ({
  onSyncRequest,
  context,
}: { onSyncRequest?: () => void } & WithApolloContext): void => {
  const { refetch: refetchCurrentUser } = useCurrentUser({ context });
  const [getToolPreferences] = useLazyQuery(GET_TOOL_PREFERENCES, {
    fetchPolicy: 'network-only',
    context: {
      ...context,
      telemetry: { ...context.telemetry, fetchPolicy: 'network-only' },
    },
  });

  useCrossTabEventsListener(NameSpaces.CROSS_WINDOW_DATA_REFETCH, async ({ source, payload }) => {
    if (source === 'remote' && payload.type === CrossWindowDataRefetchType.USER) {
      onSyncRequest?.();
      await refetchCurrentUser();
      await getToolPreferences();
    }
  });
};
